import React, { useEffect } from 'react'
import { useLocation, useParams } from "react-router-dom";
import { type, compose, defaultTo, prop, isEmpty, isNil, head, pathOr, length } from 'ramda'
import { Store } from '../../../../context/store'
import { parseObjectToArray, getTranslation, getDataByKey, getOrder, renderData, isExists, sortByInt, isNotNilDataByKey } from '../../../../helpers'
import { useFetch, useSort } from '../../../../hooks'
import HeadBar from '../../../../modules/HeadBar'
import InfoBar from '../../../../modules/InfoBar'
import Footer from '../../../../modules/Footer'
import Sort from '../../../../modules/Sort'
import Container from '../../../../components/Container'
import Boxes from '../../../../components/Boxes'
import Box from '../../../../components/Box'
import PageLoader from '../../../../components/PageLoader'
import ListItemContainer from '../../../../components/ListItemContainer'
import { InseminationStyled, StyledLinkReport } from './styled'
import Icon from '../../../../components/Icon';
import Calendar, { CalendarWrapper } from '../../../../components/Calendar';

const MonitoringPage = () => {
    const { state: { endpoint = null } = {} } = useLocation();
    const { name = '' } = useParams();
    const { actions, state: { group: { selected: selectedGroup } } } = Store()

    const { response: resMonitoring } = useFetch({
        url: `/${name}`,
        method: 'GET',
        loader: false
    })

    const { response: resMonitoringData, error: errorMonitoringData, fetching: fetchingMonitoringData, doFetch: getMonitoringData } = useFetch({
        method: 'POST',
        // action: actions.setMonitoringData
    })

    const getType = compose(
        pathOr("cow", ['type']),
        head,
        pathOr([], ['data'])
    );

    useEffect(() => {
        if (!isEmpty(name) && (!isNil(endpoint) || !isEmpty(endpoint))) {
            getMonitoringData({
                url: `/rpc/${endpoint}`,
                data: {
                    grpid: parseInt(selectedGroup, 10)
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name])

    const { sortOrder, setSortOrder, sortItems, sort: sortList } = useSort(getOrder(resMonitoring), name, sortByInt)

    useEffect(() => {
        if (resMonitoringData && type(resMonitoringData.data) === "Array") {
            const type = getType(resMonitoring);
            if (type === "zone") {
                actions.setZonesList(resMonitoringData.data)
            } else if (type === "cow") {
                actions.setCowsList(sortList(resMonitoringData.data))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resMonitoring, resMonitoringData, sortOrder])

    const renderDataState = renderData({ data: resMonitoringData, error: errorMonitoringData, fetching: fetchingMonitoringData })

    const sortBoxes = sortByInt({ direct: 'asc', key: 'order' })

    const getData = compose(defaultTo([]), prop('data'))

    const getLinkReport = () => {
        const parseData = data => {
            return {
                ...data,
                dates: data.dates && `{${data.dates.join(",")}}`,
                reports: data.reports && `{${data.reports.join(",")}}`
            }
        };
        const type = getType(resMonitoring);
        if (type === "zone") {
            const getFirstZoneId = compose(
                pathOr(null, ['row_id']),
                head,
                pathOr([], ['data'])
            );
            return {
                pathname: '/reports/zone',
                state: {
                    type: "zone",
                    dataKey: "row_id",
                    icon: "zones",
                    data: {
                        ...parseData(getDataByKey(resMonitoring, 'report')),
                        zoneid: getFirstZoneId(resMonitoringData),
                    },
                    endpointExecute: "reportzoneexecute",
                    refetch: false,
                    report: {
                        endpoint: "get_zone_report_modal_data"
                    }
                }
            }
        } else if (type === "cow") {
            const getFirstCowId = compose(
                pathOr(null, ['row_id']),
                head,
                sortList,
                pathOr([], ['data'])
            );
            return {
                pathname: '/reports/cow',
                state: {
                    type: "cow",
                    dataKey: "row_id",
                    icon: "cow",
                    data: {
                        ...parseData(getDataByKey(resMonitoring, 'report')),
                        cowid: getFirstCowId(resMonitoringData),
                    },
                    endpointExecute: "reportexecute",
                    refetch: false,
                    report: {
                        endpoint: "get_report_modal_data"
                    }
                }
            }
        } else {
            return {
                pathname: '/reports/cow'
            };
        }
    }

    const checkTypeData = dataItems => {
        switch (type(dataItems)) {
            case "Object":
                return (
                    <Boxes>
                        {
                            sortBoxes(parseObjectToArray(dataItems))
                                .map(box => (
                                    <Box
                                        key={box.label}
                                        to={{
                                            pathname: `/monitoring/${box.to}`,
                                            state: {
                                                endpoint: box.endpoint
                                            }
                                        }}
                                        title={box.label}
                                        warning={box.warning}
                                        alarm={box.alarm}
                                        active={box.showme}
                                        bordercolor={box.bordercolor}
                                        info={box.info}
                                    />
                                ))
                        }
                    </Boxes>
                )
            case "Array":
                if(isNotNilDataByKey(resMonitoring, 'calendar')) {
                    return (
                        <CalendarWrapper>
                            <Calendar
                                show={isNotNilDataByKey(resMonitoring, 'calendar')}
                                days={getDataByKey(resMonitoring, 'calendar', [])}
                                content={(renderedDays) => {
                                    const filterDays = (days) => {
                                        return days.filter(day => renderedDays.map(renderedDay => renderedDay.stamp).includes(day.stamp)).sort((a, b) => a.stamp - b.stamp);
                                    }
                                    return (
                                        <ListItemContainer
                                            daysLength={length(renderedDays)}
                                            data={sortList(parseObjectToArray(dataItems))}
                                            filterDays={filterDays}
                                        />
                                    )
                                }}
                                fullContent
                                scrollContent
                            />
                        </CalendarWrapper>
                    )
                } else {
                    return (
                        <ListItemContainer
                            data={sortList(parseObjectToArray(dataItems))}
                        />
                    )
                }
              
            default:
                return
        }
    }

    return (
        <InseminationStyled>
            <HeadBar
                title={getDataByKey(resMonitoring, 'title', '')}
            >
                {
                    isExists(sortItems) &&
                    <Sort
                        sortOrder={sortOrder}
                        setSortOrder={setSortOrder}
                        sortItems={sortItems}
                        translation={{
                            'order-close': getTranslation(resMonitoring, 'order-close'),
                            'order-title': getTranslation(resMonitoring, 'order-title')
                        }}
                    />
                }
            </HeadBar>
            {
                isNotNilDataByKey(resMonitoring, 'info') &&
                <InfoBar lastUpdate={resMonitoring.lastUpdate} translation={{ info: getTranslation(resMonitoring, 'info') }} />
            }
            <Container>
                {renderDataState({
                    fetching: () => (<PageLoader />),
                    error: error => <div>{error.toString()}</div>,
                    data: compose(
                        checkTypeData,
                        getData
                    )
                })}
            </Container>
            <Footer>
                {
                    isNotNilDataByKey(resMonitoring, 'report') && isExists(resMonitoringData.data) &&
                    <StyledLinkReport
                        to={getLinkReport()}
                    >
                        <Icon name='report' />
                    </StyledLinkReport>
                }
            </Footer>
        </InseminationStyled>
    )
}

export default MonitoringPage
